import sunglass from '../assets/img/sunglass.jpg';
//Photo by Jonny Caspari on Unsplash
import necklace from '../assets/img/necklace.jpg';
// Photo by LoboStudio Hamburg on Unsplash
import bracelet from '../assets/img/bracelet.jpg';
// Photo by Jonathan Gallegos on Unsplash
import earring from '../assets/img/earring.jpg';

export const PROMOTIONS = [
    {
        id: 0,
        name: 'Costa',
        image: sunglass,
        featured: true,
        description:
            'Costa Loreto 580 Plastic $245.00 or 4 interest-free payments of $61.25 with afterpay'
    },
    {
        id: 1,
        name: 'Kendra Scott',
        image: necklace,
        featured: false,
        description:
            'Kendra Scott Zappos Exclusive Grayson Crystal Pendant Stud Jewelry Set'
    },
    {
        id: 2,
        name: 'M&F Western',
        image: bracelet,
        featured: false,
        description: `M&F Western Bead Bracelet Set $19.00 or 4 interest-free payments of $4.75 with afterpay`
    },
    {
        id: 3,
        name: 'Lauren Ralph Lauren',
        image: earring,
        featured: false,
        description:
            'Lauren Ralph Lauren Beaded Trio Earrings $34.99 or 4 interest-free payments of $8.75 with afterpay'
    }
];